export const ONBOARDING_VIDEO_HOST = 'https://voicescript-onboarding.s3.amazonaws.com/';

export const getOnboardingVideoHost = () => ONBOARDING_VIDEO_HOST;
